<template>
  <div class="flex flex-col h-full w-full" v-if="images.length">
    <div class="flex flex-row w-full h-auto md:hidden">
      <ScrollableCarousel :value="images" :numVisible="1" :numScroll="1">
        <template #item="slotProps: { data: ImageProps; index: number }">
          <div
            class="w-full flex flex-row justify-center items-center border border-white hover:border-gray-50 rounded-xl image-grid-mobile-image-container"
          >
            <img
              :srcset="slotProps.data.srcset"
              :src="slotProps.data.url"
              @click="selectImage(slotProps.index)"
              alt="product image"
              class="w-auto max-h-96 rounded-xl cursor-pointer"
            />
          </div>
        </template>
      </ScrollableCarousel>
    </div>

    <div
      class="hidden md:flex md:flex-col justify-start items-stretch w-full h-full gap-y-4 rounded-xl image-grid-desktop-image-container"
    >
      <img
        :srcset="firstImage.srcset"
        :src="firstImage.url"
        @click="selectImage(0)"
        alt="product image"
        class="rounded-xl cursor-pointer aspect-square object-cover"
      />
      <div class="grid grid-cols-2 gap-x-4 gap-y-4">
        <div
          v-for="(image, index) in remainingImages"
          :key="index"
          class="flex flex-col justify-center items-center"
        >
          <img
            @click="selectImage(index, true)"
            :srcset="image.srcset"
            :src="image.url"
            alt="product image"
            class="w-full h-auto rounded-xl cursor-pointer"
          />
        </div>
      </div>

      <Sidebar
        v-model:visible="fullScreen"
        header=""
        position="full"
        :base-z-index="99999"
        @show="onShow"
      >
        <div class="flex flex-col md:mx-auto md:max-w-screen-xl">
          <div
            v-for="(image, index) in images as any"
            :key="index"
            class="flex flex-col justify-center items-center my-4 mx-4 overflow-auto"
            :ref="`image-${index}`"
          >
            <img
              :srcset="image.srcset"
              :src="image.url"
              alt="product image"
              class="rounded-xl"
            />
          </div>
        </div>
      </Sidebar>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Sidebar from "primevue/sidebar";
import { ScrollableCarousel } from "./ScrollableCarousel";

export interface ImageProps {
  srcset: string;
  url: string;
}
// vue 3 version below
export default defineComponent({
  components: {
    Sidebar,
    ScrollableCarousel,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fullScreen: false,
      selectedImage: 3,
    };
  },
  methods: {
    selectImage(index: number, plusOne = false) {
      this.selectedImage = plusOne ? index + 1 : index;
      this.fullScreen = true;
    },
    onShow() {
      setTimeout(() => {
        const image = this.$refs[
          `image-${this.selectedImage}`
        ] as HTMLElement[];
        if (image.length)
          image[0].scrollIntoView({ behavior: "smooth", block: "center" });
      }, 1);
    },
  },
  computed: {
    firstImage(): any {
      return this.images[0] ?? null;
    },
    remainingImages(): any[] {
      return this.images.slice(1);
    },
  },
});
</script>
